import { z } from 'zod';
import {
  PLATFORM_DEFAULTS,
  RETENTION_DAYS_MAX,
  RETENTION_DAYS_MIN,
  VENDOR_INSTRUCTIONS_MAX_CHARS,
} from './defaults.ts';
import { TenantModelsSchema } from './models.ts';
import { AppearanceSchema, DisplayModeSchema, LinkPolicySchema } from './presentation.ts';

export const TenantSettingsSchema = z.object({
  assistantName: z.string().min(1).max(80).default('Assistant'),
  aiLabel: z.string().trim().min(1).max(80).default(PLATFORM_DEFAULTS.aiLabel),
  firstMessageNotice: z
    .string()
    .trim()
    .min(1)
    .max(500)
    .default(PLATFORM_DEFAULTS.firstMessageNotice),
  creditLimitMessage: z
    .string()
    .trim()
    .min(1)
    .max(500)
    .default(PLATFORM_DEFAULTS.creditLimitMessage),
  linkPolicy: LinkPolicySchema.default(PLATFORM_DEFAULTS.linkPolicy),
  displayModes: z
    .array(DisplayModeSchema)
    .min(1)
    .default([...PLATFORM_DEFAULTS.displayModes]),
  retentionDays: z
    .number()
    .int()
    .min(RETENTION_DAYS_MIN)
    .max(RETENTION_DAYS_MAX)
    .default(PLATFORM_DEFAULTS.retentionDays),
  appearance: AppearanceSchema.default({}),
  models: TenantModelsSchema.optional(),
  vendorInstructions: z.string().trim().min(1).max(VENDOR_INSTRUCTIONS_MAX_CHARS).optional(),
  webSearch: z.boolean().default(false),
  webFetch: z.boolean().default(false),
  /** Users may save skills of their own from a chat. */
  personalSkills: z.boolean().default(true),
  scheduledTasks: z.boolean().default(false),
});
export type TenantSettings = z.infer<typeof TenantSettingsSchema>;
export type TenantSettingsInput = z.input<typeof TenantSettingsSchema>;

export function defaultTenantSettings(): TenantSettings {
  return TenantSettingsSchema.parse({});
}
